<template>
  <div>
    <embed id="payaPaymentAccountIframe" v-if="paya_url" :src="paya_url"/>
  </div>
</template>


<script>
import logger from "../lib/logger";
import {mapState} from "vuex";

export default {
  data () {
    return {
      allowed_urls: ["https://api.sandbox.payaconnect.com", "https://api.payaconnect.com"],
      response_received: false,
      form_data: {
        internal_token: '',
        token: '',
        fname: '',
        lname: '',
        exp_month: 0,
        exp_year: 0,
        last_four: '',
        brand: '',
      }
    }
  },

  mounted () {
    window.addEventListener("message", this.receiveMessage, false);
  },

  computed : {
    ...mapState({
      paya_url: state => state.billing.paya_url,
    }),
  },

  methods : {
    receiveMessage (event) {
      // Code inspired from here: https://docs.payaconnect.com/developers/api/post-message
      // Make sure the value for allowed matches the domain of the iFrame you are embedding.
      // Verify sender's identity
      if (!this.allowed_urls.includes(event.origin)) {
        return;
      }
      let data;
      try {
        data = JSON.parse(event.data)
      } catch (error) {
        logger.info('invalid data: ', event.data)
        logger.info('error: ', error)
        return
      }
      try {
        //let data = JSON.parse(event.data);
        this.form_data.internal_token = data.account_vault_api_id;
        this.form_data.token = data.id;
        this.form_data.last_four = data.last_four;
        this.form_data.brand = String(data.account_type).toUpperCase();
        let split_name = data.account_holder_name.split(' ');
        this.form_data.fname = split_name[0];
        // put the rest of the name here. it's stupid that the name is just one string
        if (split_name.length > 1) {
          this.form_data.lname = split_name.slice(1).join(' ');
        }
        this.form_data.exp_month = Number(data.exp_date.substring(0, 2));  // Not sure why they combine expiration in one string
        this.form_data.exp_year = Number('20' + data.exp_date.substring(2));
      } catch (error) {
        // If any error occurs, we continue emitting the form data. The backend will attempt to find the data in case
        // of some unforeseen error using the internal token
        logger.info('Receive Error: ', error);
      }
      this.$emit('card-added', this.form_data);
    }
  },
}
</script>


<style scoped>
#payaPaymentAccountIframe {
  width: 100%;
  height: 300px;
}
</style>



// WEBPACK FOOTER //
// PayaPaymentAccount.vue?e90e54f6